import { createPlugin } from '@backstage/core-plugin-api';

/**
 * The ai-assistant frontend plugin. It exposes no routable page — it is a global widget + context
 * that overlays the existing app. The plugin instance exists mainly to register the plugin id with
 * the app; the widget/provider are consumed as plain components (see index.ts), matching how this
 * repo already imports frontend components directly.
 */
export const aiAssistantPlugin = createPlugin({
  id: 'ai-assistant',
});
